export default {
    waistSize: [
        {
            title: '腰长',
            list: [
                '80',
                '90',
                '100',
                '110',
                '120'
            ]
        }
    ]
}